import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../store";
import { useGetRenewalsQuery } from "../../../services/ActionReports/ActionReportAPI";
import { RenewalsResponse } from "../../../services/ActionReports/ActionReportAPI.types";
import { getCurrentPeriod } from "../../../common/util/period";
import { setActiveTabs } from "../../../reducers/renewalsArReport";
import { renewalsReportTabs } from "./RenewalsActionReport";
import { storedLocale } from "../../Authentication/util";
import { useWatchlistFetch } from "../hooks/useWatchlistFetch";

export const defaultReportData = (): RenewalsResponse => {
  return {
    autoRenewal: [],
    nonAutoRenewal: [],
    gracePeriod: [],
    inRenewal: [],
    earlyRenewal: [],
    uiEnableInRenewal: false,
    uiEnableGracePeriod: false,
    uiEnableAutoRenewal: false,
    uiEnableEarlyRenewal: false,
    error: undefined,
    callResults: [],
  };
};

export const FetchRenewalsActionReportData = (skipRequest = false) => {
  const { user } = useAppSelector((state) => state.boot);
  const dispatch = useAppDispatch();

  const {
    data: payloadData,
    isFetching,
    isError,
    refetch,
  } = useGetRenewalsQuery(
    {
      Aff: user.aff,
      Abo: user.abo,
      Period: getCurrentPeriod(),
      TimeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      Locale: storedLocale(),
    },
    {
      skip: skipRequest,
    },
  );

  const { isLoading: isLoadingWatchlist } = useWatchlistFetch();

  const [isLoading, setIsLoading] = useState(true);
  const [errorStatus, setErrorStatus] = useState(false);
  const [renewalsActionReportData, setRenewalsActionReportData] = useState<RenewalsResponse>(defaultReportData());

  useEffect(() => {
    // Only stop loading when both report data AND watchlist are ready
    setIsLoading(isFetching || isLoadingWatchlist);
    setErrorStatus(isError);

    if (!isFetching && !isError && payloadData) {
      setRenewalsActionReportData(payloadData);

      const activeTabs: renewalsReportTabs[] = [];

      if (payloadData.uiEnableInRenewal) {
        activeTabs.push(renewalsReportTabs.IN_RENEWAL_PERIOD);
      }

      if (payloadData.uiEnableGracePeriod) {
        activeTabs.push(renewalsReportTabs.IN_GRACE_PERIOD);
      }

      if (payloadData.uiEnableEarlyRenewal) {
        activeTabs.push(renewalsReportTabs.EARLY_RENEWAL_PERIOD);
      }

      if (payloadData.uiEnableAutoRenewal) {
        activeTabs.push(renewalsReportTabs.NON_AUTO_RENEWAL);
        activeTabs.push(renewalsReportTabs.ON_AUTO_RENEWAL);
      }

      dispatch(setActiveTabs(activeTabs));
    }
  }, [isFetching, isError, payloadData, dispatch, isLoadingWatchlist]);

  return { isLoading, renewalsActionReportData, errorStatus, refetch };
};
